import { CSSProperties } from "react"

const fullScreenImageStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    left: 0,
    objectFit: 'cover'
}

type FullScreenImageProps = {
    src: string
    extraStyles?: CSSProperties
    alt: string,
}

export const FullScreenImage = ({ src: image, extraStyles, alt }: FullScreenImageProps) => {

    const allStyles = {
        ...fullScreenImageStyle,
        ...extraStyles,
    }
    
    return (
        <img src={image} style={allStyles} alt={alt} />
    )

}
